import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-detailed-bulk-export-view',
  templateUrl: './detailed-bulk-export-view.component.html',
  styleUrl: './detailed-bulk-export-view.component.scss'
})
export class DetailedBulkExportViewComponent {
  @Output() buttonAction = new EventEmitter<any>();

  onButtonAction(event: any){
  this.buttonAction.emit(event);
 }

}
